import { Injectable, Injector } from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import 'rxjs/add/observable/throw';

import { AuthService } from './auth.service';
import {Router} from '@angular/router';
import {BackendApi, localhost} from '../config/backend-api';
import {catchError, retry} from 'rxjs/operators';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private authService: AuthService;
  private PUBLIC_URLS =       // TODO: DA MODIFICARE PER OGNI URL AGGIUNTA
    [
      localhost + BackendApi.LOGIN.toString(),
      localhost + BackendApi.REGISTRATION.toString(),
      localhost + BackendApi.CHANGE_PWD.toString(),
      localhost + BackendApi.CONFIRM_CHANGE_PWD.toString(),
  ];

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.authService = this.injector.get(AuthService);
    const token: string = this.authService.getToken();

    // excluding change password config url from search
    if (!((this.PUBLIC_URLS.includes(request.url)) || request.url.includes(this.PUBLIC_URLS[3]))) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`),
        params: request.params
      });
    }
    return next.handle(request).pipe(
      retry(3)); // TODO: CHANGE
    }
  }

@Injectable()
  export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request)
      .catch((response: any) => {
        if (response instanceof HttpErrorResponse && response.status === 401) {
          console.log(response);
        }
        return Observable.throw(response);
      });
  }
}
